module.exports = __webpack_public_path__ + "static/img/login-img.e4dbc3db.png";